import { defineStore } from 'pinia'
import { http } from '@/api'
import { useAdminSocketStore } from './adminSocket'

const TOKEN_KEY = 'admin_token'
const ADMIN_KEY = 'admin_user'

export const useAdminAuthStore = defineStore('adminAuth', {
  state: () => ({
    admin: null,
    token: null,
    authenticated: false,
    loading: false,
    error: null,
    _restored: false,
  }),
  actions: {
    async restore() {
      if (this._restored) return
      this._restored = true
      const token = localStorage.getItem(TOKEN_KEY)
      const adminRaw = localStorage.getItem(ADMIN_KEY)
      if (token) this.token = token
      if (adminRaw) {
        try {
          this.admin = JSON.parse(adminRaw)
        } catch {}
      }
      const hasCachedSession = !!this.token && !!this.admin
      if (hasCachedSession) {
        this.authenticated = true
      }
      try {
        const res = await http.get('/admin/auth/me')
        if (res?.admin) {
          this.admin = res.admin
          this.authenticated = true
          localStorage.setItem(ADMIN_KEY, JSON.stringify(res.admin))
        } else if (!hasCachedSession) {
          this.clearAuth()
        }
      } catch (e) {
        if (!hasCachedSession && this.token) {
          this.clearAuth()
        }
      }
    },
    async login({ email, password }) {
      this.loading = true
      this.error = null
      try {
        const res = await http.post('/admin/auth/login', { email, password })
        if (!res?.ok) throw new Error(res?.error || 'login_failed')
        this.admin = res.admin
        this.authenticated = true
        this.token = res.token || null
        if (res.token) localStorage.setItem(TOKEN_KEY, res.token)
        localStorage.setItem(ADMIN_KEY, JSON.stringify(res.admin))
        const sock = useAdminSocketStore()
        sock.connect()
        return res.admin
      } catch (e) {
        this.error = e.message || 'login_failed'
        throw e
      } finally {
        this.loading = false
      }
    },
    async logout() {
      try {
        await http.post('/admin/auth/logout')
      } catch {}
      this.clearAuth()
      const sock = useAdminSocketStore()
      sock.disconnect()
    },
    clearAuth() {
      this.admin = null
      this.token = null
      this.authenticated = false
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(ADMIN_KEY)
    },
  },
})
